import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('mailArchive');
export const actions = helper.createActions('mailArchive', actionTypes);
